import { useState, useEffect, useContext } from "react";
import React from "react";
import t from "../../Utils/Translation";
import { useParams } from "react-router-dom";
import axios from "axios";
import {
  AUTHORIZED_URL_PREFIX,
  PROFILE_URL_WITHOUT_PARAM,
  AxiosConfig,
} from "../../Utils/Constants";
import "./profile.css";
import Loading from "../common/Loading";
import { notify, pleaseRefreshError } from "../../Utils/Notificator";
import { LykioContext } from "../routing/LykioAuthorizedRoute";
import TimelineBox from "./TimelineBox";
import StoriesUploadBox from "./StoriesUploadBox";
import ProfileAwards from "./ProfileAwards";
import ProfileImageArea from "./ProfileImageArea";
import ProfileStats from "./ProfileStats";
import FavouriteUnits from "./FavouriteUnits";
import ProfileAccessCodes from "./ProfileAccessCodes";
import RightFooter from "../common/RightFooter";
import EniRadarChart from "./EniRadarChart";
import ActivityFeedback from "./ActivityFeedback";

const Profile = () => {
  const [isLoading, setIsLoading] = useState(true);
  const context = useContext(LykioContext);
  const contextUser = context && context.userDetails;
  const tenantProperties = context.tenantProperties;
	const [enableSchools, setEnableSchools] = useState(true);
  // const enableSchools = tenantProperties && tenantProperties.enableSchools;
  const { userId } = useParams();
  const [user, setUser] = useState("");
  const [stories, setStories] = useState([]);
  const [favourites, setFavourites] = useState([]);
  const [userHistoryItems, setUserHistoryItems] = useState([]);
  const [activeAccessCodes, setActiveAccessCodes] = useState([]);

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const { data } = await axios.post(
          `${AUTHORIZED_URL_PREFIX}${PROFILE_URL_WITHOUT_PARAM}`,
          { userId },
          AxiosConfig()
        );
        setUser(data.user);
        setStories(data.stories);
        setFavourites(data.favourites);
        setUserHistoryItems(data.userHistoryItems);
        setActiveAccessCodes(data.activeAccessCodes);
        setEnableSchools(data.enableSchools);
        
        setIsLoading(false);
        if (!data.success) {
          notify(pleaseRefreshError);
        }
      } catch (error) {
        console.log(error);
        notify(pleaseRefreshError);
      }
    };
    fetchProfileData();
  }, [userId]);

  return (
    <div className="lykioccs-main-content lykiocss-bacheca">
      {isLoading ? (
        <Loading />
      ) : (
        <React.Fragment>
            <div style={{margin:'4em 9em 4em 9em'}}>
              <div className="row">
                <div className="col-lg-3">
                  <ProfileImageArea
                    userId={userId}
                    user={user}
                    contextUser={contextUser}
                  />

                  <div className="card mb-4 ">
                    <ProfileStats user={user} />
                  </div>
                  <div className="row">
                    <div>
                    <TimelineBox style={{backgroundColor: 'white', minWidth: '25em'}} userHistoryItems={userHistoryItems} />
                    <StoriesUploadBox stories={stories} />
                    <FavouriteUnits stories={favourites} />
                    </div>
                  </div>
                </div>

                <div className="col-lg-5">
                  <div className="row">
                  <div style={{minHeight:'25em', minWidth:'25em', backgroundColor:"white", borderRadius:'5px', marginBottom: '1em', color: 'black'}}>
                    <div style={{margin:'1rem 0 2rem 0'}}>
                      <div style={{fontSize:'20px', textAlign:'center', marginBottom:'1rem'}}>{t("General result")}</div>
                      <div style={{fontSize:'16px', textAlign:'center'}}>{t("Sum of all answers that exhibit a bias")}</div>
                    </div>
                    <EniRadarChart/>
                  </div>
                  </div>
                  <div className="row">
                    {/*<TimelineBox style={{backgroundColor: 'white', minWidth: '25em'}} userHistoryItems={userHistoryItems} />
                    <StoriesUploadBox stories={stories} />
                    <FavouriteUnits stories={favourites} />*/}
                    <ActivityFeedback />
                  </div>
                </div>
                
                <div className="col-lg-4">
                  <div className="row">
                  <ProfileAwards user={user} awards={contextUser && contextUser.awards}/>
                  </div>
                </div>

              </div>
            </div>
        </React.Fragment>
      )}
    {enableSchools && <RightFooter/>}
    </div>
  );
};

export default Profile;
